import { createContext } from "react";
import { GenericSimulatorContextType } from "./types";

export const GenericSimulatorContext = createContext<GenericSimulatorContextType | undefined>(undefined);

/** Alias used by some hooks (e.g. useConsole) */
export const GenericSimulatorProviderContext = GenericSimulatorContext;

export type { Modals, ModalType } from "./types";
